import { render, staticRenderFns } from "./SelectPicker.vue?vue&type=template&id=52221045&"
import script from "./SelectPicker.vue?vue&type=script&lang=ts&"
export * from "./SelectPicker.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPicker.vue?vue&type=style&index=0&id=52221045&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports